/**
 * Payload encoded in the deposit QR (wallet address; memo appended when required).
 */
export function buildBinanceDepositQrValue({ address, tag } = {}) {
  const trimmedAddress = String(address || '').trim();
  if (!trimmedAddress) return '';
  const trimmedTag = String(tag || '').trim();
  if (!trimmedTag) return trimmedAddress;
  return `${trimmedAddress}:${trimmedTag}`;
}
